module.exports = __webpack_public_path__ + "img/gaizao.c45b4226.png";